const DividerPhone = ({ className }) => {
    return (
        <svg width="279" className={className} height="1" viewBox="0 0 279 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="279" y1="0.5" x2="-4.37114e-08" y2="0.499976" stroke="#E6E7EA" />
        </svg>
    );
};

export default DividerPhone;